import React, {useState} from 'react';
import styled from 'styled-components';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import {Link, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {loggedOut} from '../redux/userSlice.js';
import {useAuth0} from '@auth0/auth0-react';
import {useVisitorData} from '@fingerprintjs/fingerprintjs-pro-react';

// import Upload from "./Upload";

const Container = styled.div`
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.bgLighter};
  height: 56px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding: 0px 20px;
  position: relative;
`;

const Search = styled.div`
  width: 40%;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  color: ${({ theme }) => theme.text};
`;

const Input = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
  color: ${({ theme }) => theme.text};
`;

const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  border-radius: 3px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const User = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
`;

// const Avatar = styled.img`
//   width: 32px;
//   height: 32px;
//   border-radius: 50%;
//   background-color: #999;
// `;

const AuthNav = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`;

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data } = useVisitorData();
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [q, setQ] = useState("");
  const { currentUser } = useSelector((state) => state.user);

  const handleLogout = async () => {
    // e.preventDefault();
    if (currentUser) {
      dispatch(loggedOut());
      navigate("/");
    } else if (user) {
      logoutWithRedirect();
    } else {
      logoutWithRedirect();
    }
  };

  const logoutWithRedirect = () => {
    logout({
      returnTo: window.location.origin,
    });
  };

  async function loginWithFingerprint() {
    if (data) {
      return loginWithRedirect({
        fingerprint: `${data.visitorId} ${data.requestId}`,
      });
    }
    return console.log(data);
  }
  // onClick = { loginWithFingerprint };

  return (
    <>
      <Container>
        <Wrapper>
          <Search>
            <Input
              placeholder="Search"
              onChange={(e) => setQ(e.target.value)}
            />
            <SearchOutlinedIcon onClick={() => navigate(`/search?q=${q}`)} />
          </Search>

          {isAuthenticated || currentUser ? (
            <AuthNav>
              <Link to="/profile">
                <User>
                  <ContactsOutlinedIcon />
                </User>
              </Link>
              <p></p>
              <Button onClick={handleLogout}>
                <AccountCircleOutlinedIcon />
                Logout
              </Button>
            </AuthNav>
          ) : (
            <Button onClick={loginWithFingerprint}>
              <AccountCircleOutlinedIcon />
              SIGN IN
            </Button>
          )}
        </Wrapper>
      </Container>
    </>
  );
};

export default Navbar;
